import React, { useState } from "react";
import { Field } from "redux-form";
import { email, required } from "redux-form-validators";

import Title from "../../../components/Title";
import Spacer from "../../../components/Spacer";
import Section from "../../../components/Section";
import AsyncForm from "../../../components/AsyncForm";
import Input from "../../../components/Field/Input/Input";

import style from "./style.module.css";
import { Button } from "../../../components/Field";
import Background from "../../../components/Background";

export default function Newsletter(props) {
    const {
        title = "",
        description = "",
        bg_image = {},
        success_title = "",
        success_description = "",
    } = props;
    const [success, setSuccess] = useState(false);

    return (
        <Section className={style.signin}>
            <div className={style.signinWrapper}>
                <div className={style.signinBg}>
                    <Background src={bg_image} size="2560x1440" cPosition="bottomLeft" />
                </div>
                {
                    success === false && (
                        <div className={style.formWrapper}>
                            <Title
                                tag="h3"
                                className="fontTeko"
                                transform="uppercase"
                                align="center"
                            >
                                {title}
                            </Title>
                            <Spacer size="16" />
                            <Title
                                tag="p"
                                align="center"
                            >
                                {description}
                            </Title>
                            <Spacer />
                            <AsyncForm
                                url="/account/newsletters"
                                permissionText={false}
                                hasGetAction={false}
                                showToastOnSuccess={false}
                                onSave={({ data }) => {
                                    if(data.status === 200){
                                        setSuccess(true);
                                    }
                                }}
                                render={({ fetching }) => (
                                    <div className={style.formWrap}>
                                        <div className={style.form}>
                                            <div className={style.formRow}>
                                                <Field
                                                    name="email"
                                                    component={Input}
                                                    validate={[required(), email()]}
                                                    required={true}
                                                    placeholder="Enter your email"
                                                    label="Please Enter Your Email"
                                                />
                                            </div>
                                            <Spacer size="24" />
                                            <div className={`${style.formRow} ${style.formSubmit}`}>
                                                <div className={style.colRow}>
                                                    <Button
                                                        submit={true}
                                                        color="buttonPrimary"
                                                        size="buttonFullWidth"
                                                        fetching={fetching}
                                                        label="SUBMIT"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            />
                        </div>
                    )
                }
                {
                    success === true && (
                        <div className={style.formWrapper}>
                            <Title
                                tag="h3"
                                className="fontTeko"
                                transform="uppercase"
                                align="center"
                            >
                                {success_title}
                            </Title>
                            <Spacer size="16" />
                            <Title
                                tag="p"
                                align="center"
                            >
                                {success_description}
                            </Title>
                        </div>
                    )
                }
            </div>
        </Section>
    )
}